/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Topsection_Platforms1Inputs */

const id_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform:`)
};

const ms_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform:`)
};

const da_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme:`)
};

const de_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformen:`)
};

const en_us2_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms:`)
};

const es_es2_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas:`)
};

const es_mx2_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas:`)
};

const fil_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Platform:`)
};

const fr_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plateformes :`)
};

const it_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piattaforme:`)
};

const hu_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformok:`)
};

const nl_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms:`)
};

const no_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformer:`)
};

const pl_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformy:`)
};

const pt_br2_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms:`)
};

const pt_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas:`)
};

const ro_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme:`)
};

const fi_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alustat:`)
};

const sv_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformar:`)
};

const vi_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nền tảng:`)
};

const tr_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformlar:`)
};

const cs_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformy:`)
};

const bg_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформи:`)
};

const ru_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформы:`)
};

const uk_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформи:`)
};

const ar_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنصات:`)
};

const hi_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म:`)
};

const th_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพลตฟอร์ม:`)
};

const ja_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム：`)
};

const zh_cn2_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms:`)
};

const zh_hant1_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms:`)
};

const ko_components_topsection_platforms1 = /** @type {(inputs: Components_Topsection_Platforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms:`)
};

/**
* | output |
* | --- |
* | "Platforms:" |
*
* @param {Components_Topsection_Platforms1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_topsection_platforms1 = /** @type {((inputs?: Components_Topsection_Platforms1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Topsection_Platforms1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_topsection_platforms1(inputs)
	if (locale === "ms") return ms_components_topsection_platforms1(inputs)
	if (locale === "da") return da_components_topsection_platforms1(inputs)
	if (locale === "de") return de_components_topsection_platforms1(inputs)
	if (locale === "en-US") return en_us2_components_topsection_platforms1(inputs)
	if (locale === "es-ES") return es_es2_components_topsection_platforms1(inputs)
	if (locale === "es-MX") return es_mx2_components_topsection_platforms1(inputs)
	if (locale === "fil") return fil_components_topsection_platforms1(inputs)
	if (locale === "fr") return fr_components_topsection_platforms1(inputs)
	if (locale === "it") return it_components_topsection_platforms1(inputs)
	if (locale === "hu") return hu_components_topsection_platforms1(inputs)
	if (locale === "nl") return nl_components_topsection_platforms1(inputs)
	if (locale === "no") return no_components_topsection_platforms1(inputs)
	if (locale === "pl") return pl_components_topsection_platforms1(inputs)
	if (locale === "pt-BR") return pt_br2_components_topsection_platforms1(inputs)
	if (locale === "pt") return pt_components_topsection_platforms1(inputs)
	if (locale === "ro") return ro_components_topsection_platforms1(inputs)
	if (locale === "fi") return fi_components_topsection_platforms1(inputs)
	if (locale === "sv") return sv_components_topsection_platforms1(inputs)
	if (locale === "vi") return vi_components_topsection_platforms1(inputs)
	if (locale === "tr") return tr_components_topsection_platforms1(inputs)
	if (locale === "cs") return cs_components_topsection_platforms1(inputs)
	if (locale === "bg") return bg_components_topsection_platforms1(inputs)
	if (locale === "ru") return ru_components_topsection_platforms1(inputs)
	if (locale === "uk") return uk_components_topsection_platforms1(inputs)
	if (locale === "ar") return ar_components_topsection_platforms1(inputs)
	if (locale === "hi") return hi_components_topsection_platforms1(inputs)
	if (locale === "th") return th_components_topsection_platforms1(inputs)
	if (locale === "ja") return ja_components_topsection_platforms1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_topsection_platforms1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_topsection_platforms1(inputs)
	return ko_components_topsection_platforms1(inputs)
});
export { components_topsection_platforms1 as "components.topSection.platforms" }